import createIcon from '../../createIcon';

/**
 * @component @name CircleNotifications
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk0xMiAxOC41QzExLjE3IDE4LjUgMTAuNSAxNy44MyAxMC41IDE3SDEzLjVDMTMuNSAxNy44MyAxMi44MyAxOC41IDEyIDE4LjVaTTE3IDE2SDdWMTVMOCAxNFYxMS4zOUM4IDkuMjcgOS4wMyA3LjQ3IDExIDdWNi41QzExIDUuOTMgMTEuNDMgNS41IDEyIDUuNUMxMi41NyA1LjUgMTMgNS45MyAxMyA2LjVWN0MxNC45NyA3LjQ3IDE2IDkuMjggMTYgMTEuMzlWMTRMMTcgMTVWMTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CircleNotifications = createIcon('CircleNotifications', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 18.5C11.17 18.5 10.5 17.83 10.5 17H13.5C13.5 17.83 12.83 18.5 12 18.5ZM17 16H7V15L8 14V11.39C8 9.27 9.03 7.47 11 7V6.5C11 5.93 11.43 5.5 12 5.5C12.57 5.5 13 5.93 13 6.5V7C14.97 7.47 16 9.28 16 11.39V14L17 15V16Z',
      key: 'f1hzc',
    },
  ],
]);

export default CircleNotifications;
